import type { CellClassParams, ColDef, ExcelStyle } from 'ag-grid-community';

export const AGGRID_DEFAULT_ROW_HEIGHT = 36;
export const AGGRID_DEFAULT_HEADER_HEIGHT = 36;
export const AGGRID_DEFAULT_PAGINATION_HEIGHT = 56;

export const AGGRID_DEFAULT_COL_DEF: ColDef = {
    minWidth: 80,
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
};

const EXCEL_EMPTY_CELL_CLASS = 'excel-empty-cell';

/**
 * AG Grid 35.2 exports an empty cell as an empty shared string, which Excel treats as text and
 * rejects in formulas (#VALUE!). Typing empty cells as Number makes Excel read them as blank.
 * TODO : Remove once we upgrade to AG Grid 36.0, which fixes this issue
 */
export const EXCEL_EMPTY_CELL_STYLE: ExcelStyle = {
    id: EXCEL_EMPTY_CELL_CLASS,
    dataType: 'Number',
};

export const EXCEL_EMPTY_CELL_CLASS_RULES: ColDef['cellClassRules'] = {
    // during the Excel export, `value` is the exported value where null is already turned into ''
    [EXCEL_EMPTY_CELL_CLASS]: ({ value }: CellClassParams) =>
        value == null || value === '',
};

const EXCEL_CURRENCY_CELL_CLASS = 'excel-currency-cell';

/**
 * Amounts are exported as raw numbers so that Excel can sum them, this style
 * displays them with the euro sign.
 */
export const EXCEL_CURRENCY_CELL_STYLE: ExcelStyle = {
    id: EXCEL_CURRENCY_CELL_CLASS,
    numberFormat: { format: '#,##0.00 "€"' },
};

export const EXCEL_CURRENCY_CELL_CLASS_RULES: ColDef['cellClassRules'] = {
    // A column is monetary when its own formatter renders numbers with the euro sign.
    // Probing with 1 rather than the cell value keeps the whole column consistent
    // (some formatters render 0 or null as '-').
    [EXCEL_CURRENCY_CELL_CLASS]: (params: CellClassParams) => {
        const { valueFormatter } = params.colDef;
        if (
            typeof params.value !== 'number' ||
            typeof valueFormatter !== 'function'
        ) {
            return false;
        }
        return valueFormatter({ ...params, value: 1 }).includes('€');
    },
};
